
import { Behavior, ChartMetadata, ChartPlugin, t } from '@superset-ui/core';
import buildQuery from '../buildQuery';
import controlPanel from './controlPanel';
import transformProps from './transformProps';
import thumbnail from './images/usa-map.png';
import example from './images/uk-map.png';
import { EchartsMapChartProps, EchartsMapFormData } from './types';
 
export default class EchartsCountryMapChartPlugin extends ChartPlugin<
   EchartsMapFormData,
   EchartsMapChartProps
 > {
   constructor() {
     super({
       buildQuery,
       controlPanel,
       loadChart: () => import('./EchartsMap'),
       metadata: new ChartMetadata({
         behaviors: [Behavior.INTERACTIVE_CHART],
         category: t('Map'),
         credits: ['https://echarts.apache.org'],
         description:
           t(`The classic. Great for showing how much of a company each investor gets, what demographics follow your blog, or what portion of the budget goes to the military industrial complex.
 
         Pie charts can be difficult to interpret precisely. If clarity of relative proportion is important, consider using a bar or other chart type instead.`),
         exampleGallery: [
           { url: thumbnail },
           { url: example },
         ],
         name: t('Country Map'),
         tags: [
           t('ECharts'),
           t('Maps'),
         ],
         thumbnail,
       }),
       transformProps,
     });
   }
}
 